import { addLog } from '@/api/common';
import { deviceFingerprintManager } from '@/plugins/eventTrackManager/deviceFingerprintManager';

import { applePayValidateMerchant } from '../../api/aggregate';

export const APPLE_PAY_LANG = {
  de: 'de-DE',
  en: 'en-GB',
  es: 'es-ES',
  fr: 'fr-FR',
  it: 'it-IT',
  nl: 'nl-NL',
  no: 'nb-NO',
  pl: 'pl-PL',
  pt: 'pt-PT',
  fi: 'fi-FI',
  sv: 'sv-SE',
  ru: 'ru-RU',
  ar: 'ar-AB',
  th: 'th-TH',
  'zh-cn': 'zh-CN',
  ja: 'ja-JP',
  'zh-tw': 'zh-TW',
  ko: 'ko-KR',
};

// 选择ApplePay后 将回调发送埋点
const sendRiskDeviceFingerPrint = (externalOrderId, data) => {
  const param = {
    m: externalOrderId || '',
    timeStamp: Date.now(),
    e: 'external_sdk_interact',
    r: data,
  };
  deviceFingerprintManager.send(param);
};

export const ApplePay = {
  initButton: async (merchantIdentifier, lang, merchantNo, externalOrderId) => {
    // 按钮初始化埋点
    sendRiskDeviceFingerPrint(externalOrderId, {
      message: 'Apple Pay initButton',
    });
    const userAgent = navigator.userAgent.toLowerCase();
    if (window.ApplePaySession) {
      // 通用验证
      try {
        var canMakePayments = await window.ApplePaySession.canMakePayments();
        if (canMakePayments) {
          return true;
        }
        addLog({
          merchantNo,
          externalOrderId,
          message: 'Apple Pay device not support(canMakePayments false):' + userAgent,
        });
        sendRiskDeviceFingerPrint(externalOrderId, {
          message: 'Apple Pay device not support(canMakePayments false):' + userAgent,
        });
        return false;
      } catch (error) {
        addLog({
          merchantNo,
          externalOrderId,
          message: 'Apple Pay canMakePayments Error',
        });
        sendRiskDeviceFingerPrint(externalOrderId, {
          message: 'Apple Pay canMakePayments Error:',
          error,
        });
        return false;
      }
    } else {
      addLog({
        merchantNo,
        externalOrderId,
        message: 'Apple Pay device not support(no ApplePaySession) :' + userAgent,
      });
      sendRiskDeviceFingerPrint(externalOrderId, {
        message: 'Apple Pay device not support(no ApplePaySession) :' + userAgent,
      });
      return false;
    }
  },
  startPay: (request, txnKey, merchantNo, externalOrderId, callback, closeLoading) => {
    // 开始支付埋点
    sendRiskDeviceFingerPrint(externalOrderId, {
      message: 'Apple Pay startPay,request：' + JSON.stringify(request),
    });
    if (window.ApplePaySession) {
      try {
        var session = new window.ApplePaySession(1, request);
      } catch (error) {
        sendRiskDeviceFingerPrint(externalOrderId, {
          message: 'Apple Pay session error:',
          error: error + '',
        });
      }
      // 服务器验证Session
      session.onvalidatemerchant = event => {
        // 服务器验证Session埋点
        sendRiskDeviceFingerPrint(externalOrderId, {
          message: 'Apple Pay onvalidatemerchant',
        });
        // Call your own server to request a new merchant session.
        const params = {
          key: txnKey,
          website: window.location.hostname,
          instCode: 'ApplePay',
          verifyUrl: event.validationURL,
        };
        applePayValidateMerchant(params)
          .then(res => {
            try {
              if (res.respCode === '20000') {
                const mSession = JSON.parse(res.data);
                // 服务器验证Session埋点
                sendRiskDeviceFingerPrint(externalOrderId, {
                  message: 'Apple Pay onvalidatemerchant success',
                });
                session.completeMerchantValidation(mSession);
              } else if (closeLoading) {
                session.completeMerchantValidation({});
                closeLoading();
              }
            } catch (error) {
              sendRiskDeviceFingerPrint(externalOrderId, {
                message: 'session.completeMerchantValidation error:',
                error,
              });
            }
          })
          .catch(err => {
            session.completeMerchantValidation({});
            console.error('Error fetching merchant session', err);
            sendRiskDeviceFingerPrint(externalOrderId, {
              message: 'Error fetching merchant session',
              err,
            });
            if (closeLoading) {
              closeLoading();
            }
          });
      };
      // Payment Authorized
      session.onpaymentauthorized = event => {
        // 支付授权埋点
        sendRiskDeviceFingerPrint(externalOrderId, {
          message: 'Apple Pay onpaymentauthorized',
        });
        try {
          const applePaymentToken = event.payment.token; // ApplePay支付Token
          if (callback) {
            callback(applePaymentToken, session);
          } else if (closeLoading) {
            closeLoading();
          }
        } catch (error) {
          sendRiskDeviceFingerPrint(externalOrderId, {
            message: 'Error fetching merchant session',
            error,
          });
        }
      };
      // 取消支付
      session.oncancel = event => {
        if (closeLoading) {
          closeLoading();
        }
        addLog({
          merchantNo,
          externalOrderId,
          message: 'Apple Pay canceled',
        });
        sendRiskDeviceFingerPrint(externalOrderId, {
          message: 'Apple Pay canceled',
          event,
        });
        console.log('apple pay canceled');
      };

      try {
        // 开始支付埋点
        sendRiskDeviceFingerPrint(externalOrderId, {
          message: 'Apple Pay begin',
        });
        session.begin();
      } catch (error) {
        sendRiskDeviceFingerPrint(externalOrderId, {
          message: 'session.begin error:',
          error,
        });
      }
    } else {
      console.log('Apple Pay is not available');
      sendRiskDeviceFingerPrint(externalOrderId, {
        message: 'Apple Pay is not available',
      });
      if (closeLoading) {
        closeLoading();
      }
    }
  },
};
